import pick from "lodash/pick";
import queryString from 'query-string';
import React from 'react';
import { connect, DispatchProp } from "react-redux";
import { NavLink } from "react-router-dom";

import { clearBreadcrumbs, updateBreadcrumbs } from 'core/actions/paramsActions';
import initialState from 'core/reducers/initialState';
import { IBreadcrumb } from 'core/util/IBreadcrumb';
import IProps from 'core/util/IProps';
import UrlUtil from "core/util/UrlUtil";

export type Breadcrumbs = ((target: ILinkTarget, existingBreadcrumbs: IBreadcrumb[]) => IBreadcrumb[]);

export interface ILinkTarget {
	pathname: string; search: string;
}

export interface ILinkProps extends IProps {
	children?: React.ReactNode | ((args: ILinkStateProps) => React.ReactNode);

	// option 1: target page panel instance w/ path prefix
	instance?: string; // target page panel instance
	prefix?: string;

	// option 2: path of panel ids
	pagePath?: string[];

	// option 3: pass a literal path
	to?: string;

	// option 4: pass the link target
	target?: ILinkTarget;

	params?: object;
	preserveParams?: boolean;
	breadcrumbs?: Breadcrumbs;
}

interface ILinkStateProps {
	active: boolean;
	existingBreadcrumbs: IBreadcrumb[];
	target: ILinkTarget;
}

function mapStateToProps(state: typeof initialState, ownProps: ILinkProps): ILinkStateProps {

	const existingBreadcrumbs = state.params.breadcrumbs;

	let target: ILinkTarget = ownProps.target;

	if (!target) {
		if (ownProps.to) {
			// 3. literal path
			const searchIndex = ownProps.to.indexOf('?');
			target = {
				pathname: ownProps.to.slice(0, ownProps.to.indexOf('?')),
				search: searchIndex > -1 ? ownProps.to.slice(ownProps.to.indexOf('?') - 1) : undefined
			};
		} else {
			let pathname: string;
			if (ownProps.pagePath) {
				// 2. panel instance id path
				pathname = UrlUtil.getPagePathLink(state, ownProps.pagePath);
			} else {
				// 3. target page instance id + literal prefix
				const sPanel = state.config.panels[ownProps.instance];
				pathname = UrlUtil.getLink(ownProps.prefix, sPanel && sPanel.path);
			}

			const existingParams = queryString.parse((state as any).router.location.search);

			target = {
				pathname,
				search: queryString.stringify(ownProps.preserveParams ? {...existingParams, ...ownProps.params || {}} : ownProps.params)
			};
		}
	}

	const currentPath = (state as any).router.location.pathname;
	const active = target.pathname === currentPath || target.pathname.substring(0, target.pathname.length - 1) === currentPath;

	return { active, existingBreadcrumbs, target };
}

type ResultProps = ILinkStateProps & DispatchProp & ILinkProps;

function Link(props: ResultProps) {

	const linkProps: any = {
		className: props.className,
		exact: true,
		onClick: () => {
			// update breadcrumbs
			if (typeof props.breadcrumbs === 'function') {
				// props.breadcrumbs(pick(props, ['instance', 'prefix', 'pagePath', 'params', 'preserveParams']) as any
				props.dispatch(updateBreadcrumbs(props.breadcrumbs(props.target, props.existingBreadcrumbs)));
			} else {
				props.dispatch(clearBreadcrumbs());
			}
		},
		style: props.style,
		to: props.target
	};

	let content: React.ReactNode;

	if (typeof props.children === 'function') {
		content = (props.children as any)(props);
	} else {
		content = props.children;
	}

	return (
		<NavLink {...linkProps}>
			{content}
		</NavLink>
	);
}

export default connect(mapStateToProps)(Link);



// WEBPACK FOOTER //
// ./src/common/views/pageLink/Link.tsx